import { FeaturesComponent } from './features.component';
import { ImageBlockComponent } from './image-block/image-block.component';
import { VideoBlockComponent } from './video-block/video-block.component';
import { CommonModule } from '@angular/common';

export const FEATURES_COMPONENT_DECLARATIONS = [
  FeaturesComponent,
  ImageBlockComponent,
  VideoBlockComponent,
];

export const FEATURES_COMPONENT_IMPORTS = [CommonModule];

export const FEATURES_COMPONENT_ENTRY_COMPONENTS = [
  ImageBlockComponent,
  VideoBlockComponent,
];
